
declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    autocompletePaperGrid: true;
    cardList: true;
  }
}


export default function Paper(theme: any) {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 3,
      },

      variants: [
        {
          props: { variant: "outlined" },
          style: { borderColor: theme.palette.grey[500_12] },
        },
        {
          props: { variant: "autocompletePaperGrid" },
          style: {
            display: "flex",
            height: "100%",
            width: "100%",
            marginLeft: 0,
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            backgroundColor: theme.palette.grey[700],
            color: theme.palette.grey[0],

            "& ul": {
              display: "flex",
            },

            "& ::-webkit-scrollbar": {
              width: "8px",
              height: "100%",
            },
            "& ::-webkit-scrollbar-track": {
              background: theme.palette.grey[900],
            },
            "& ::-webkit-scrollbar-thumb": {
              borderRadius: "8px",
              background: theme.palette.grey[700],
              border: `1px solid ${theme.palette.grey[300]}`,
            },
            "& ::-webkit-scrollbar-button": {
              display: "none",
            },
          },
        },
      ],

      styleOverrides: {
        root: {
          backgroundImage: "none",
          borderColor: "transparent",
          borderRadius: theme.shape.borderRadius * 2,
          boxShadow: "none",
          backgroundColor: "transparent",
          margin: theme.spacing(0, 0.375),
          "&.MuiMenu-paper": {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
          },
        },
      },
    },
  };
}
